import { Instance } from 'tippy.js'
import { Direction, ValidationIssue } from 'api'
import { ValidationCellRenderer, ValidationCellRendererParams } from 'view/components/datagrid'
import './DirectionCellRenderer.css'

export class DirectionCellRenderer extends ValidationCellRenderer {
  protected getFieldValidationIssues(params: ValidationCellRendererParams): ValidationIssue[] {
    if (!params.validationField) {
      return []
    } else {
      return super.getFieldValidationIssues(params)
    }
  }

  protected refreshCell(element: HTMLElement, tooltip: Instance, params: ValidationCellRendererParams) {
    super.refreshCell(element, tooltip, params)
    this.refreshDirectionStyle(element, params)
  }

  private refreshDirectionStyle(element: HTMLElement, params: ValidationCellRendererParams) {
    element.classList.toggle('direction-cell', true)
    element.classList.toggle('direction-buy', params.value === Direction.BUY)
    element.classList.toggle('direction-sell', params.value === Direction.SELL)
  }
}
